import { Colors, Metrics } from '@origin-digital/style-guide';
import * as React from 'react';
import styled from 'styled-components';

import { SuggestionsProps } from './Suggestions.types';
import Suggestion from './Suggestion';

const SuggestionsList = styled.div`
  position: absolute;
  z-index: 9999;
  width: calc(100% - 2px);
  padding: ${Metrics.Spacing.P_Y_XS}px 0;
  background-color: ${Colors.WHITE};
  border-radius: 0 0 3px 3px;
  border: 1px solid ${Colors.GREY24};
  border-top: none;
  top: 56px;
`;

const Suggestions: React.StatelessComponent<SuggestionsProps> = ({
  ...props
}: SuggestionsProps) => {
  const { onClick, query, suggestions } = props;

  return (
    <SuggestionsList data-id="suggestions-list">
      {suggestions.map(item => (
        <Suggestion
          item={item}
          data-id={item.label}
          key={item.addressId}
          label={item.label}
          onClick={onClick}
          query={query}
        />
      ))}
    </SuggestionsList>
  );
};

export { Suggestions as default };
